/**
 * Helpers to convert a review cycle aggregation result into a service-contract.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "convertReviewCycleModelToServiceContract", {
    enumerable: true,
    get: function() {
        return convertReviewCycleModelToServiceContract;
    }
});
// ============================================================================
// Status & Type Derivation
// ============================================================================
const deriveV2Status = (cycle)=>{
    if (cycle.closed) return "closed";
    const statusMap = {
        Active: "active",
        Completed: "completed",
        Scheduled: "scheduled",
        "N/A": "active"
    };
    return statusMap[cycle.status] || "active";
};
const deriveV2Type = (cycle)=>{
    if (cycle.automated) return "automated";
    if (cycle.department) return "group";
    return "manual";
};
const convertReviewCycleModelToServiceContract = (input)=>{
    const { totalReviews, completedReviews } = input;
    const v2Type = deriveV2Type(input);
    const v2Status = deriveV2Status(input);
    const base = {
        _id: input._id,
        name: input.name,
        workflow: input.workflow,
        startDate: input.start_date,
        adminsOnly: input.admins_only ?? false,
        progress: {
            completedReviews,
            totalReviews
        },
        status: v2Status,
        jobStatus: input.job_status,
        easyAddConfigCount: input.easy_add_configs_populated?.filter((c)=>c.is_active).length ?? 0,
        completeDate: input.complete_date ?? undefined,
        createdAt: input.created_at,
        creator: input.creator ?? undefined,
        updatedAt: input.updated_at,
        updatedBy: input.updated_by
    };
    if (v2Type === "automated") {
        return {
            ...base,
            type: "automated",
            automationStatus: input.automation_status
        };
    }
    if (v2Type === "group") {
        return {
            ...base,
            type: "group",
            department: {
                _id: input.department,
                name: input.department_name || ""
            }
        };
    }
    return {
        ...base,
        type: "manual"
    };
};
